/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
// eslint-disable-next-line import/order
import { createSelector } from "@reduxjs/toolkit";
import { damageApi } from "./api-slice";
import { IDamageListResponse, IDamageResponse } from "@bvi/api-interfaces/response/manage-base-data";

export const selectDamage = createSelector(
  (response?: IDamageListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectDamageListResult = () =>
  damageApi.endpoints.getDamageList.select();

export const selectResponse = (data?: IDamageResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};

